import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'distance',
})
@Injectable({ providedIn: 'root' })
export class DistancePipe implements PipeTransform {

    transform(value: number, ...args): string {
        if(!value && value != 0) return "?";
        if(value < 1000) return Math.ceil(value) + " m";
        if(value >= 1000 && value < 10000) return Math.ceil(value / 100) / 10 + " km";
        if(value >= 10000) return Math.ceil(value / 1000) + " km";
        else return "?"
    }
}
